import * as actionType from "../types/ActionTypes";
import axios from "../../shared/axios";
import Swal from "sweetalert2";
import { baseUrl } from "../../shared/baseURL";
import { redirect } from "react-router-dom";

export const courseregSetData = (coursereg) => {
  return {
    type: actionType.COURSE_REG_SET_DATA,
    coursereg: coursereg,
  };
};

export const courseregFailData = (error) => {
  return {
    type: actionType.COURSE_REG_FAIL_DATA,
    error: error,
  };
};

export const courseregLoading = () => {
  return {
    type: actionType.COURSE_REG_LOADING,
  };
};

export const courseregGetData = (data) => {
  return (dispatch) => {
    dispatch(courseregLoading());
    axios
      .get(baseUrl + "/course-registration", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        //console.log(res.data, "res");
        dispatch(courseregSetData(res.data));
      })

      .catch((error) => dispatch(courseregFailData(error)));
  };
};

export const deleteCourseregFail = (error) => {
  return {
    type: actionType.DELETE_COURSE_REG_FAIL,
    error: error,
  };
};

export const deleteCoursereg = (id, data) => {
  return (dispatch) => {
    if (id) {
      axios
        .delete(baseUrl + `/course-registration/${data.id}`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data?.token,
          },
        })
        .then(() => {
          Swal.fire("Deleted!", "Your file has been deleted.", "success").then(
            () => {
              dispatch(courseregGetData(data));
            }
          );
        })
        .catch((error) => dispatch(deleteCourseregFail()));
    }
  };
};

export const postCourseregDataStart = () => {
  return {
    type: actionType.POST_COURSE_REG_DATA_START,
  };
};

export const postCourseregDataFail = (error) => {
  return {
    type: actionType.POST_COURSE_REG_DATA_FAIL,
    error: error,
  };
};

export const postCourseregDataSuccess = (success) => {
  return {
    type: actionType.POST_COURSE_REG_DATA_SUCCESS,
    success: success,
  };
};

export const courseregPostLoading = () => {
  return {
    type: actionType.COURSE_REG_POST_LOADING,
  };
};

export const courseregPostLoadingReset = () => {
  return {
    type: actionType.COURSE_REG_POST_LOADING_RESET,
  };
};
export const postAjivasanAct = (coursereg, setSubmitting, resetForm) => {
  return (dispatch) => {
    dispatch(postCourseregDataStart());
    dispatch(courseregPostLoading());
    axios
      .post(baseUrl + "/course-registration", coursereg, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(postCourseregDataSuccess(res.data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Redirecting To Payment Page",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (setSubmitting) {
            setSubmitting(false);
          }
          resetForm();
          // console.log("res.data", res.data);
          // console.log("coursereg", coursereg);
          if (res.data?.student_no == "1") {
            window.open(
              "https://payu.in/web/CA89B34F6CF10D8AB7DA1776E8A0B88D",
              "_self"
            );
          } else if (res.data?.student_no == "2") {
            window.open(
              "https://payu.in/web/CD65139230ED2046CED9E1F824EB2DE2",
              "_self"
            );
          } else if (res.data?.student_no == "3") {
            window.open(
              "https://payu.in/web/615B94B18E6F4D5DB10E5ABB1A6772B3",
              "_self"
            );
          } else if (res.data?.student_no == "4") {
            window.open(
              "https://payu.in/web/ABF32AA95A596047D8EAC5E7AABA74AE",
              "_self"
            );
          } else if (res.data?.student_no == "5") {
            window.open(
              "https://payu.in/web/DC18B9C815539A67DA2DC33A9DC2A130",
              "_self"
            );
          } else {
            Swal.fire({
              position: "warning",
              icon: "warning",
              title: "Something Went Wrong",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(postCourseregDataFail(error));
      });
  };
};
export const postCourseregData = (coursereg, setSubmitting, resetForm, url) => {
  return (dispatch) => {
    dispatch(postCourseregDataStart());
    dispatch(courseregPostLoading());
    axios
      .post(baseUrl + "/course-registration", coursereg, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(postCourseregDataSuccess(res.data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Redirecting To Payment Page",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (setSubmitting) {
            setSubmitting(false);
          }
          resetForm();
          window.open(url, "_blank");
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(postCourseregDataFail(error));
      });
  };
};

// NEW ACTION: Direct payment redirect for iOS Safari compatibility (Frontend only solution)
export const postCourseregDataWithBackendRedirect = (coursereg, setSubmitting, resetForm) => {
  return (dispatch) => {
    dispatch(postCourseregDataStart());
    dispatch(courseregPostLoading());

    // STRATEGY: Use HTML form submission instead of window.location
    // This is 100% iOS Safari compatible and happens synchronously

    // Create a hidden form
    const form = document.createElement('form');
    form.method = 'GET';
    form.action = 'https://ajivasanmusicacademy.com/payumoney/public/payu-money-payment';
    form.style.display = 'none';

    // Add payment parameters as hidden inputs
    const params = {
      firstname: coursereg.clientname,
      courseid: coursereg.course_id || '',
      email: coursereg.clientemail,
      phone: coursereg.clientphone,
      amount: coursereg.totalfees,
      productinfo: 'ajivasanmusic',
    };

    Object.keys(params).forEach(key => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = params[key];
      form.appendChild(input);
    });

    // Append form to body
    document.body.appendChild(form);

    // Save registration data in background (fire-and-forget)
    // Use sendBeacon for reliability (works even after navigation starts)
    const formData = new FormData();
    Object.keys(coursereg).forEach(key => {
      formData.append(key, coursereg[key]);
    });

    // Try sendBeacon first (most reliable), fallback to axios
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(coursereg)], { type: 'application/json' });
      navigator.sendBeacon(baseUrl + "/course-registration", blob);
    } else {
      // Fallback for older browsers
      axios
        .post(baseUrl + "/course-registration", coursereg, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .catch((error) => {
          console.error("Background save failed:", error);
        });
    }

    // Submit form immediately (iOS Safari allows this)
    form.submit();
  };
};
export const postCourse = (coursereg, setSubmitting, resetForm) => {
  return (dispatch) => {
    dispatch(postCourseregDataStart());
    dispatch(courseregPostLoading());
    axios
      .post(baseUrl + "/course-registration", coursereg, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(postCourseregDataSuccess(res.data));

        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Registered",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (setSubmitting) {
            setSubmitting(false);
          }
          resetForm();
          // window.open(url, "_blank")
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(postCourseregDataFail(error));
      });
  };
};
// demo form submit
export const postDemoCourseregPay = (
  coursereg,
  setSubmitting,
  resetForm,
  url
) => {
  return (dispatch) => {
    dispatch(postCourseregDataStart());
    dispatch(courseregPostLoading());
    axios
      .post(baseUrl + "/course-registration", coursereg, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(postCourseregDataSuccess(res.data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Thank You ! Our team will get back to you within 48 hours",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (setSubmitting) {
            setSubmitting(false);
          }
          resetForm();
          window.open(url, "_blank");
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(postCourseregDataFail(error));
      });
  };
};
export const postDemoEnqCourse = (coursereg, setSubmitting, resetForm) => {
  return (dispatch) => {
    dispatch(postCourseregDataStart());
    dispatch(courseregPostLoading());
    axios
      .post(baseUrl + "/course-registration", coursereg, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(postCourseregDataSuccess(res.data));

        Swal.fire({
          position: "success",
          icon: "success",
          title: "Thank You ! Our team will get back to you within 48 hours",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (setSubmitting) {
            setSubmitting(false);
          }
          resetForm();
          // window.open(url, "_blank")
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(postCourseregDataFail(error));
      });
  };
};

export const updateCourseregDataStart = () => {
  return {
    type: actionType.UPDATE_COURSE_REG_DATA_START,
  };
};

export const courseregUpdateLoading = () => {
  return {
    type: actionType.COURSE_REG_UPDATE_LOADING,
  };
};

export const updateCourseregDataFail = (error) => {
  return {
    type: actionType.UPDATE_COURSE_REG_DATA_FAIL,
    error: error,
  };
};

export const updateCourseregDataSuccess = (success) => {
  return {
    type: actionType.UPDATE_COURSE_REG_DATA_SUCCESS,
    success: success,
  };
};

export const updateCourseregData = (data, coursereg, toggle, setSubmitting) => {
  return (dispatch) => {
    dispatch(updateCourseregDataStart());
    dispatch(courseregUpdateLoading());

    axios
      .put(baseUrl + `/course-registration/${data.id}`, coursereg, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(updateCourseregDataSuccess(res.data));
        dispatch(courseregGetData(data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Updated !",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (toggle) {
            toggle();
          }
          if (setSubmitting) {
            setSubmitting(false);
          }
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(updateCourseregDataFail(error));
      });
  };
};


// export const payuPayment = (coursereg, setSubmitting, resetForm) => {
//   return (dispatch) => {
//     dispatch(postCourseregDataStart());
//     dispatch(courseregPostLoading());
//     axios
//       .post(baseUrl + "/payu-payment", coursereg, {
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json",
//           // Authorization: "Bearer " + data.token,
//         },
//       })
//       .then((res) => {
//         dispatch(postCourseregDataSuccess(res.data));

//         Swal.fire({
//           position: "success",
//           icon: "success",
//           title: "Successfully Registered",
//           showConfirmButton: false,
//           timer: 1500,
//         }).then(() => {
//           if (setSubmitting) {
//             setSubmitting(false);
//           }
//           resetForm();
//         });
//       })
//       .catch((error) => {
//         if (setSubmitting) {
//           setSubmitting(false);
//         }
//         dispatch(postCourseregDataFail(error));
//       });
//   };
// };
